















import { Component, Mixins } from 'vue-property-decorator';

import OfflineMixin from '@/mixins/OfflineMixin';

@Component({
  name: 'Notifier',
})
export default class Notifier extends Mixins(OfflineMixin) {
  showNotification = false;

  public mounted() {
    this.$on('online', this.toggleShowNotification);
    this.$on('offline', this.toggleShowNotification);
  }

  toggleShowNotification(): void {
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;
    }, 5000);
  }
}
